import script from "./MenuBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBlock.vue?vue&type=script&setup=true&lang=js"

import "./MenuBlock.vue?vue&type=style&index=0&id=502dd298&scoped=true&lang=scss"
import "./MenuBlock.vue?vue&type=style&index=1&id=502dd298&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-502dd298"]])

export default __exports__